/*
 * 앱 공통 '대화' · '공유' 아이콘 — 2026-10-08 탐색 액션바에서 고른 모양으로 앱 전체를 맞췄다("대화랑 공유 아이콘 다른 곳에서도 다 싱크").
 * Phosphor 채운 아이콘(react-icons/pi — 이미 설치된 react-icons 안이라 새 의존성 없음).
 * - ChatIcon  : 점 세 개 둥근 말풍선 — 대화 수 · 대화 시작 · 대화 이어가기
 * - ShareIcon : 유튜브식 굽은 화살표 — 링크 · 이미지 공유
 * 채팅 '모드'(소설/채팅 전환) · 메신저 명령어 · 고객센터처럼 '대화'가 아닌 뜻의 말풍선은 이걸 쓰지 않는다.
 */
export {
  PiChatCircleDotsFill as ChatIcon,
  PiShareFatFill as ShareIcon,
} from 'react-icons/pi'
